<template>
  <div id="app">
    <div v-if="!IsMobile">
      <fy-head></fy-head>
    </div>
    <div v-if="IsMobile">
      <fyHeadMobile :isShowMenu="headMobileVisible" :onClose="closeMenu"></fyHeadMobile>
      <div class="content">
        <div class="fy-head">
          <img
            v-show="!headMobileVisible"
            class="fy-head-menu"
            :src="MenuOpen"
            @click="showDrawer"
          />
          <router-link to="/"><img :src="logo"/></router-link>
        </div>
      </div>
    </div>
    <router-view />
    <div class="footer" v-if="!IsMobile">
      <div class="record-number">
        <a
          style="margin-left: 42px"
          href="https://beian.miit.gov.cn/?spm=a2c4g.11186623.J_9220772140.115.26b47b3dHmt3yq#/Integrated/index"
          >备案号 浙ICP备18018923号-1</a
        >
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=5176.19720258.J_9220772140.117.47cb2c4atLhNCE"
        >
          <img :src="recordNo" style="float: left" />
          <p style="float: left; margin-left: 10px; line-height: 20px">
            浙公网安备 33010302003666号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { IsMobile } from "./utils";
import fyHead from "./components/tpl/top-head/top-head.vue";
import fyHeadMobile from "./components/tpl/top-head-mobile/top-head-mobile.vue";
import logo from "@/assets/home-logo.png";
import recordNo from "@/assets/beianhao.png";
import MenuOpen from "@/assets/menu-open.png";
export default Vue.extend({
  name: "fy",
  components: {
    fyHead,
    fyHeadMobile,
  },
  data() {
    return {
      IsMobile,
      logo,
      recordNo,
      MenuOpen,
      headMobileVisible: false,
    };
  },
  created() {
    // IsMobile && this.getHomeConfig();
  },
  mounted() {},
  watch: {
    $route() {
      this.headMobileVisible = false;
      document.body.classList.remove("fixed");
    },
  },
  methods: {
    closeMenu() {
      document.body.classList.remove("fixed");
      this.headMobileVisible = false;
    },
    showDrawer() {
      document.body.classList.add("fixed");  
      this.headMobileVisible = true;
    },
    getHomeConfig() {
      this.$https
        .get("/api/homeConfig/getConfigByType", {
          params: {
            type: 1,
          },
        })
        .then((res) => {
          const img = res.data;
          img?.id && (this.logo = img.imgPath);
        });
    },
  },
});
</script>
<style lang="scss" scoped>
.head {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  margin-bottom: 15px;
}
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  .record-number {
    text-align: center;
    font-size: 12px;
    a {
      display: block;
      color: #9b9b9b;
      img {
        width: 20px;
        display: inline-block;
        height: 20px;
        margin-right: 12px;
      }
    }
  }
}
</style>